export const safeParseInt = (value: string, radix: number) => {
  const parsed = parseInt(value, radix);

  if (isNaN(parsed)) {
    return null;
  }

  return parsed;
};

export const safeParseFloat = (value: string) => {
  const parsed = parseFloat(value);

  if (isNaN(parsed)) {
    return null;
  }

  return parsed;
};

export const percentageToComponents = (props: {
  percentage: number;
  decimalCount: number;
}): {
  sign: '+' | '-';
  fraction: string;
  whole: string;
} => {
  const { percentage, decimalCount } = props;

  // Round percentage to how ever many decimal places.
  const decimalFactor = 10 ** decimalCount; // This will be 10 for 1 decimal place, 100 for 2, 1000 for 3, etc.
  const roundedPercentage =
    Math.round(percentage * decimalFactor) / decimalFactor;
  const fractionNum = Math.abs(roundedPercentage) % 1;

  return {
    sign: roundedPercentage >= 0 ? '+' : '-',
    fraction: fractionNum.toFixed(decimalCount).substring(2),
    whole: Math.floor(Math.abs(roundedPercentage)).toString(10),
  };
};

export const isNumericValue = (s: string) => {
  const str = s.trim();
  return (
    !isNaN(Number(str)) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str))
  ); // ...and ensure strings of whitespace fail
};

export const isDateValue = (s: string) => {
  const str = s.trim();

  // This regex is not perfect, but it's good enough for our purposes.
  return /^\d{4}-\d{2}-\d{2}$/.test(str);
};
